// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/AssetView/AssetDetails/styles.css
// module id = 2232
// module chunks = 0